export default __webpack_public_path__ + "static/ma-partners-tools-1-62aa9157e411a96551b04397cd27051b.svg";